export enum EnergySource {
  GAS = 'Gas',
  ELECTRICITY = 'Electricity',
  STEAM = 'Steam',
  COAL = 'Coal',
  SOLID_FUEL = 'SolidFuel',
  NONE = 'None',
}

export enum Region {
  ANY = 'any',
  AMERICA = 'america',
  EUROPE = 'europe',
  ASIA = 'asia',
}

export const EnergySourceNames: Record<EnergySource, string> = {
  [EnergySource.COAL]: 'Coal',
  [EnergySource.ELECTRICITY]: 'Electricity',
  [EnergySource.GAS]: 'Gas',
  [EnergySource.SOLID_FUEL]: 'SolidFuel',
  [EnergySource.STEAM]: 'Steam',
  [EnergySource.NONE]: 'None',
};

export enum SocketState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  CALCULATING = 'calculating',
  RECONNECTING = 'reconnecting',
}
